import { useRef, useState } from 'react'
import type { SubmitHandler } from 'react-hook-form'
import { AiPromptModal } from '@/components/commons/ai-prompt-modal'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Container } from '@/components/ui/container'

import { Stars01Icon } from '@/components/ui/icons'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Scrollbar } from '@/components/ui/scrollbar'
import { OpsVettingHero } from '@/features/ops-vetting/components/ops-vetting-atoms'
import { useMerchCopyAi } from '@/features/ops-vetting/hooks/use-merch-copy-ai'
import { SERVICES_PROMPT } from '@/features/ops-vetting/prompts/service-prompt'
import { ServiceVettingMerchInputForm } from '@/features/service-vetting/components/service-vetting-merch-input-form'
import { ServiceVettingMerchOutputForm } from '@/features/service-vetting/components/service-vetting-merch-output-form'
import type {
	ServiceMerchandisingInputSchema,
	ServiceMerchandisingOutputSchema
} from '@/features/service-vetting/form-schemas'
import { useTranslation } from '@/translations/i18n'

export const ServiceCopyTraining = () => {
	const { t } = useTranslation()
	const { aiResponse, isLoading, onMerchCopyAiCall, resetAiResponse } =
		useMerchCopyAi<ServiceMerchandisingOutputSchema>()
	const finalSubmitRef = useRef<HTMLButtonElement | null>(null)
	const aiSubmissionRef = useRef<HTMLButtonElement | null>(null)
	const [currentPrompt, setCurrentPrompt] = useState<string>(SERVICES_PROMPT)

	const handleAiSubmission: SubmitHandler<ServiceMerchandisingInputSchema> = (
		data
	) => {
		resetAiResponse()
		onMerchCopyAiCall(data, currentPrompt)
	}

	const handleFinalSubmission: SubmitHandler<
		ServiceMerchandisingOutputSchema
	> = (data) => {
		console.log('handleFinalSubmission', data)
	}

	return (
		<div className='grid h-full grid-cols-[minmax(0,1fr)] grid-rows-[minmax(0,1fr)] overflow-hidden'>
			<ScrollArea scrollbar={<Scrollbar />}>
				<Container
					className='grid grid-cols-[minmax(0,1fr)] grid-rows-[auto_minmax(0,1fr)]'
					fullWidth
				>
					<OpsVettingHero
						align='center'
						fullWidth
						justify='space-between'
					>
						<h3>Service Copy Training</h3>
						<div className='flex gap-2'>
							<ButtonLegacy
								disabled={isLoading}
								onClick={() => aiSubmissionRef.current?.click()}
								type='button'
								variant='secondary'
							>
								<Stars01Icon />
								{t('vetting:merch.commons.improve_with_ai')}
							</ButtonLegacy>
							<AiPromptModal
								currentPrompt={currentPrompt}
								isLoading={isLoading}
								onPromptChange={(newPrompt) =>
									setCurrentPrompt(newPrompt)
								}
								promptType='services'
								trigger={
									<ButtonLegacy
										disabled={isLoading}
										type='button'
										variant='tertiary'
									>
										Customize prompt
									</ButtonLegacy>
								}
							/>
						</div>
					</OpsVettingHero>

					<div className='mt-6 mb-10 flex w-full overflow-hidden rounded-2xl border border-neutral-200'>
						<ServiceVettingMerchInputForm
							aiSubmissionRef={aiSubmissionRef}
							defaultValues={{}}
							handleAiSubmissionCb={handleAiSubmission}
						/>

						<ServiceVettingMerchOutputForm
							defaultValues={
								aiResponse as ServiceMerchandisingOutputSchema
							}
							finalSubmitRef={finalSubmitRef}
							handleFinalSubmissionCb={handleFinalSubmission}
							isLoading={isLoading}
						/>
					</div>
				</Container>
			</ScrollArea>
		</div>
	)
}
